import React, { useCallback } from "react";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { UsersCard } from "@radarly/models/cards";
import { getDateFromClause } from "@radarly/models/clause/getter";
import {
  isHorizontalBarChartDataviz,
  isTopAuthorsDataviz,
} from "@radarly/models/dataviz";
import {
  InfluencerLensFactory,
  SearchableInfluencer,
} from "@radarly/models/influencer";
import { useFragment } from "../fragment";
import { CardProps } from "../model";
import Cloud from "./cloud";
import HorizontalBarChart from "./horizontal-bar-chart";
import TopAuthors from "./top-authors";

const RadarlyAuthorsCards = ({
  openPostsPanel,
  card,
  timezone,
  forceReload,
  readOnly,
  nowDate,
  height,
  ...props
}: CardProps<UsersCard>) => {
  const project = useCurrentProject();
  const fragment = useFragment(
    card.fragments[0],
    props.clause,
    props.from,
    props.to,
    timezone
  );
  const dataviz = card.dataviz;
  const title = card.title;
  const onClickInfluencer = useCallback(
    (influencer: SearchableInfluencer) => {
      const { from, to } = getDateFromClause(fragment.request.query);
      const influencerLens = InfluencerLensFactory.create(influencer.user);
      openPostsPanel({
        clause: fragment.request.query,
        period: {
          from,
          to,
        },
        title,
        timezone,
        focusClause: {
          and: [{ query: influencerLens.getQuery() }],
        },
      });
    },
    [fragment.request.query, openPostsPanel, timezone, title]
  );

  return isTopAuthorsDataviz(dataviz) ? (
    <TopAuthors
      fragment={fragment}
      project={project}
      dataviz={dataviz}
      title={title}
      height={height}
      onClickItem={openPostsPanel && !readOnly ? onClickInfluencer : null}
      timezone={timezone}
      forceReload={forceReload}
      nowDate={nowDate}
    />
  ) : isHorizontalBarChartDataviz(dataviz) ? (
    <HorizontalBarChart
      fragment={fragment}
      project={project}
      dataviz={dataviz}
      title={title}
      height={height}
      onClickItem={openPostsPanel && !readOnly ? onClickInfluencer : null}
      timezone={timezone}
      forceReload={forceReload}
      nowDate={nowDate}
    />
  ) : (
    <Cloud
      fragment={fragment}
      project={project}
      dataviz={dataviz}
      title={title}
      height={height}
      onClickItem={openPostsPanel && !readOnly ? onClickInfluencer : null}
      timezone={timezone}
      forceReload={forceReload}
      nowDate={nowDate}
    />
  );
};

export default RadarlyAuthorsCards;
